import { MerchantList, MerchantParticipation } from 'types/entities'
import {
  EditableSection,
  EditableSectionTerm,
  EditableSectionTermRow,
  EditableSectionValue,
} from 'components/EditableSection'
import { Button, useDisclosure } from '@ritualco/jutsu'
import { ReactComponent as SettingsIcon } from 'assets/Icons/Settings.svg'
import { MerchantParticipationModal } from 'components/Modals/MerchantParticipationModal'

interface ParticipationSectionProps {
  merchantParticipation?: MerchantParticipation
  merchantListName?: string
  merchantLists?: MerchantList[]
  handleFormSubmission: (merchantParticipation: MerchantParticipation) => void
}
export const ParticipationSection = ({
  merchantParticipation,
  merchantListName,
  merchantLists,
  handleFormSubmission,
}: ParticipationSectionProps) => {
  const getRedeemableTitle = () => {
    switch (merchantParticipation?.type) {
      case 'all_merchants':
        return 'All Ritual Restaurants'
      case 'workspace':
        return 'Restaurants in my building'
      case 'merchant_list':
        return `Restaurants of ${merchantListName}`
      case 'radius':
        return `Restaurants within ${merchantParticipation?.merchantRadius} ${merchantParticipation?.merchantRadiusUnit}`
    }
  }
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <EditableSection
        title={'Participating Restaurants'}
        action={
          <Button
            colorScheme="transparent"
            variant="outline"
            leftIcon={<SettingsIcon style={{ height: 18, width: 18 }} />}
            onClick={onOpen}
          >
            Manage
          </Button>
        }
      >
        <EditableSectionTermRow>
          <EditableSectionTerm>Redeemable at</EditableSectionTerm>
          <EditableSectionValue>{getRedeemableTitle()}</EditableSectionValue>
        </EditableSectionTermRow>
      </EditableSection>
      {isOpen && (
        <MerchantParticipationModal
          isOpen={isOpen}
          onClose={onClose}
          onSubmit={handleFormSubmission}
          merchantLists={merchantLists}
          merchantParticipation={merchantParticipation}
        />
      )}
    </>
  )
}
